<template>
  <div id="app" :class="{ login: login.role == null }">
    <topPanel v-if="login.role != null" />
    <spinner />
    <notificator />

    <user v-if="login.role == 'User'" />
    <judge v-else-if="login.role == 'Judge'" />
    <admin v-else-if="login.role == 'Admin'" />
    <login v-else />
    <footer></footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import topPanel from "./components/top-panel";
import spinner from "./components/spinner";
import notificator from "./components/notificator";
import login from "./master_pages/login";
import user from "./master_pages/user";
import judge from "./master_pages/judge";
import admin from "./master_pages/admin";

export default {
  name: "app",
  components: {
    topPanel,
    spinner,
    notificator,
    login,
    user,
    judge,
    admin,
},
  computed: {
    ...mapState(["login"])
  }
};
</script>

<style lang="sass">
@import "./sass/_constants"

// reset
*
  margin: 0
  padding: 0

  border: none
  border-radius: 0
  outline: none
  color: inherit
  background: none

  text-decoration: none
  font-family: 'Nunito', sans-serif
  font-weight: 300
  font-size: inherit
  line-height: 1
input::placeholder
  text-align: center
h1, h2, h3
  font-weight: bold
h1
  font-size: 2rem
h2
  font-size: 1.5rem
h3
  font-size: 1.2rem
// base
html
  width: 100%
  height: 100%
body
  width: 100%
  height: 100%

  color: $c-default
  background-color: $bc-default
#app
  display: grid
  width: 100%
  height: 100%
  &:not(.login)
    grid-template-rows: auto 1fr auto
    .notificator
      grid-row: 2
      grid-column: 1
      z-index: 3
    main
      grid-row: 2
      grid-column: 1
      padding: 0 2rem
footer
  height: 2rem
</style>
